import {
  Box,
  Button,
  CardMedia,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { sell_nft } from "../../../keychain/login";
import axios from "axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  color: "white",
  display: "flex",
  flexDirection: { xs: "column", lg: "row" },
};

export const ViewInventario = ({ paginas }) => {
  const { especiales = [], generalNft = [] } = useSelector(
    (state) => state.userSlice
  );
  const { informacion } = useSelector((state) => state.userSlice);

  const [barajitas, setBarajita] = useState([]);
  const [selector, setSelector] = useState({});
  const [open, setOpen] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [precio, setPrecio] = useState("");
  const [idNft, setIdNft] = useState("");
  const [cartas, setCartas] = useState([...especiales, ...generalNft]);

  // filtros
  const [filtroRareza, setFiltroRareza] = useState("");
  const [filtroTipo, setFiltroTipo] = useState("");
  const [busqueda, setBusqueda] = useState("");
  const [orden, setOrden] = useState("cantidad_desc");
  const [soloConNft, setSoloConNft] = useState(false);
  const [soloConStockMercado, setSoloConStockMercado] = useState(false);

  const rarezaPeso = {
    L: 4,
    E: 3,
    R: 2,
    C: 1,
  };

  const getAllCard = async () => {
    let data = [];
    let bandera = false;
    let contador = 0;

    do {
      const result = await axios.post(
        "https://api.primersion.com/contracts/",
        {
          jsonrpc: "2.0",
          id: 1,
          method: "find",
          params: {
            contract: "nft",
            table: "NFTHUESOinstances",
            query: {},
            limit: 1000,
            offset: 1000 * contador,
            indexes: [],
          },
        }
      );

      if (result.data?.result?.length > 0) {
        contador++;
        data = [...result.data.result, ...data];
      } else {
        bandera = true;

        let dataTemp = [...especiales, ...generalNft].map((card) => ({
          ...card,
          cantidad: card?.cantidad || 0,
        }));

        data.forEach((e) => {
          if (e?.account !== "lavino") {
            dataTemp = dataTemp.map((card) =>
              card?.ide === e?.properties?.ID
                ? {
                    ...card,
                    cantidad: (card?.cantidad || 0) + 1,
                  }
                : card
            );
          }
        });

        setCartas(dataTemp);
      }
    } while (!bandera);
  };

  const handleClose3 = () => {
    setOpen3(false);
    setPrecio("");
  };

  const handleOpen = (card) => {
    setSelector(card);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (!informacion?.nombre) return;

    getAllCard();

    let total = [];
    if (paginas === 2) total = especiales;
    if (paginas === 1) total = generalNft;

    setBarajita(total);
  }, [paginas, informacion?.nombre, especiales, generalNft]);

  const nfttotal = useMemo(() => {
    return [...(informacion?.nftEspecial || []), ...(informacion?.nft || [])];
  }, [informacion?.nftEspecial, informacion?.nft]);

  const inventarioConDatos = useMemo(() => {
    return barajitas.map((card) => {
      const nftUser = nfttotal.find((i) => i?.ide === card?.ide);
      const mercado = cartas.find((i) => i?.ide === card?.ide);

      return {
        ...card,
        tipo: card?.id?.[0] || "",
        cantidadUsuario: nftUser?.cantidad || 0,
        nft: nftUser?.nft || [],
        cantidadMercado: mercado?.cantidad || 0,
      };
    });
  }, [barajitas, nfttotal, cartas]);

  const inventarioFiltrado = useMemo(() => {
    let resultado = [...inventarioConDatos];

    if (filtroRareza) {
      resultado = resultado.filter((card) => card?.rareza === filtroRareza);
    }

    if (filtroTipo) {
      resultado = resultado.filter((card) => card?.tipo === filtroTipo);
    }

    if (busqueda.trim()) {
      const texto = busqueda.toLowerCase().trim();
      resultado = resultado.filter(
        (card) =>
          String(card?.id || "").toLowerCase().includes(texto) ||
          String(card?.ide || "").toLowerCase().includes(texto) ||
          String(card?.nombre || "").toLowerCase().includes(texto)
      );
    }

    if (soloConNft) {
      resultado = resultado.filter((card) => Number(card?.cantidadUsuario) > 0);
    }

    if (soloConStockMercado) {
      resultado = resultado.filter((card) => Number(card?.cantidadMercado) > 0);
    }

    resultado.sort((a, b) => {
      switch (orden) {
        case "cantidad_asc":
          return (a?.cantidadUsuario || 0) - (b?.cantidadUsuario || 0);

        case "cantidad_desc":
          return (b?.cantidadUsuario || 0) - (a?.cantidadUsuario || 0);

        case "rareza_desc":
          return (rarezaPeso[b?.rareza] || 0) - (rarezaPeso[a?.rareza] || 0);

        case "rareza_asc":
          return (rarezaPeso[a?.rareza] || 0) - (rarezaPeso[b?.rareza] || 0);

        case "mercado_desc":
          return (b?.cantidadMercado || 0) - (a?.cantidadMercado || 0);

        case "id_asc":
          return String(a?.id || "").localeCompare(String(b?.id || ""));

        default:
          return 0;
      }
    });

    return resultado;
  }, [
    inventarioConDatos,
    filtroRareza,
    filtroTipo,
    busqueda,
    orden,
    soloConNft,
    soloConStockMercado,
  ]);

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      {/* FILTROS */}
      <Box
        sx={{
          background: "rgba(0,0,0,0.35)",
          width: "95%",
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          p: 1,
          mb: 1,
          borderRadius: 1,
          alignItems: "center",
        }}
      >
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel sx={{ color: "white" }}>Rareza</InputLabel>
          <Select
            value={filtroRareza}
            label="Rareza"
            onChange={(e) => setFiltroRareza(e.target.value)}
            sx={{ color: "white" }}
          >
            <MenuItem value="">Todas</MenuItem>
            <MenuItem value="C">C</MenuItem>
            <MenuItem value="R">R</MenuItem>
            <MenuItem value="E">E</MenuItem>
            <MenuItem value="L">L</MenuItem>
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel sx={{ color: "white" }}>Tipo</InputLabel>
          <Select
            value={filtroTipo}
            label="Tipo"
            onChange={(e) => setFiltroTipo(e.target.value)}
            sx={{ color: "white" }}
          >
            <MenuItem value="">Todos</MenuItem>
            <MenuItem value="E">E</MenuItem>
            <MenuItem value="G">G</MenuItem>
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 180 }}>
          <InputLabel sx={{ color: "white" }}>Ordenar</InputLabel>
          <Select
            value={orden}
            label="Ordenar"
            onChange={(e) => setOrden(e.target.value)}
            sx={{ color: "white" }}
          >
            <MenuItem value="cantidad_desc">Mis NFTs ↓</MenuItem>
            <MenuItem value="cantidad_asc">Mis NFTs ↑</MenuItem>
            <MenuItem value="rareza_desc">Rareza ↓</MenuItem>
            <MenuItem value="rareza_asc">Rareza ↑</MenuItem>
            <MenuItem value="mercado_desc">Mercado ↓</MenuItem>
            <MenuItem value="id_asc">ID</MenuItem>
          </Select>
        </FormControl>

        <TextField
          size="small"
          label="Buscar"
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          placeholder="id, ide o nombre"
          sx={{
            minWidth: 220,
            input: { color: "white" },
            label: { color: "white" },
          }}
        />

        <Button
          variant={soloConNft ? "contained" : "outlined"}
          onClick={() => setSoloConNft(!soloConNft)}
        >
          Solo con NFTs
        </Button>

        <Button
          variant={soloConStockMercado ? "contained" : "outlined"}
          onClick={() => setSoloConStockMercado(!soloConStockMercado)}
        >
          Solo mercado
        </Button>

        <Button
          color="warning"
          variant="outlined"
          onClick={() => {
            setFiltroRareza("");
            setFiltroTipo("");
            setBusqueda("");
            setOrden("cantidad_desc");
            setSoloConNft(false);
            setSoloConStockMercado(false);
          }}
        >
          Limpiar
        </Button>
      </Box>

      {/* ALBUM */}
      <Box
        sx={{
          background: "rgba(0,0,0,0.3)",
          height: "100%",
          width: "95%",
          display: "flex",
          flexWrap: "wrap",
          overflow: "auto",
        }}
      >
        {inventarioFiltrado.map((card) => (
          <Box
            sx={{ position: "relative", width: "125px", mr: 1, mb: 1 }}
            key={card?.ide}
          >
            <Box sx={{ position: "absolute", color: "white", zIndex: 100 }}>
              {card?.tipo} - {card?.cantidadUsuario}
            </Box>

            <Box
              sx={{
                position: "absolute",
                color: "red",
                zIndex: 100,
                right: 5,
                background: "black",
                px: 0.5,
                borderRadius: 0.5,
              }}
            >
              {card?.cantidadMercado}
            </Box>

            <CardMedia
              onClick={() =>
                !card?.cantidadUsuario || handleOpen(card)
              }
              sx={{
                filter: `grayscale(${card?.cantidadUsuario > 0 ? 0 : 1})`,
                width: "125px",
                cursor: "pointer",
                border:
                  filtroRareza && card?.rareza === filtroRareza
                    ? "2px solid gold"
                    : "2px solid transparent",
                borderRadius: 1,
              }}
              component="img"
              image={card?.url}
              alt="Inicial"
            />

            <Typography
              sx={{
                color: "white",
                fontSize: "0.8rem",
                textAlign: "center",
                mt: 0.5,
              }}
            >
              {card?.rareza} | {card?.id}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* MODAL CARD INFO */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style, justifyContent: "center", alignItems: "center" }}>
          {selector?.ide && (
            <Box sx={{ position: "relative", width: "125px" }}>
              <Box
                sx={{
                  display: "flex",
                  position: "absolute",
                  color: "white",
                }}
              >
                {selector?.id?.[0]} - {selector?.cantidadUsuario || 0}
              </Box>

              <CardMedia
                sx={{ width: "125px", cursor: "pointer" }}
                component="img"
                image={selector?.url}
                alt="Inicial"
              />
            </Box>
          )}

          <Box sx={{ height: "100px", width: "100%", overflow: "auto" }}>
            {selector?.nft?.length > 0 &&
              selector.nft.map((item) => (
                <Box
                  key={item}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid gray",
                    py: 0.5,
                  }}
                >
                  <Typography>{item}-</Typography>
                  <Typography>{selector.id}</Typography>

                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => {
                      setIdNft(item);
                      setOpen3(true);
                    }}
                  >
                    Sell
                  </Button>
                </Box>
              ))}
          </Box>
        </Box>
      </Modal>

      {/* DIALOG PRECIO */}
      <Dialog
        open={open3}
        onClose={handleClose3}
        PaperProps={{
          sx: {
            background: "#222730",
            width: { xs: 280, sm: 360 },
            borderRadius: 2,
          },
        }}
      >
        <DialogContent
          sx={{
            overflow: "hidden",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: 2,
            py: 3,
          }}
        >
          <DialogContentText
            sx={{
              fontSize: "1.4rem",
              color: "white",
              fontWeight: "bold",
              textAlign: "center",
              mb: 1,
            }}
          >
            Select a Price
          </DialogContentText>

          <TextField
            autoFocus
            margin="dense"
            id="price"
            label="Precio"
            type="number"
            fullWidth
            variant="standard"
            InputLabelProps={{ sx: { color: "#ccc" } }}
            inputProps={{ min: 0, style: { color: "white" } }}
            onChange={(e) => {
              setPrecio(e.target.value);
            }}
          />

          <DialogActions
            sx={{
              width: "100%",
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              mt: 2,
              justifyContent: "center",
            }}
          >
            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                if (precio === "") return;
                sell_nft(idNft, precio, "VIPHUESO");
              }}
            >
              SELL VIPHUESO
            </Button>

            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                if (precio === "") return;
                sell_nft(idNft, precio, "SWAP.HIVE");
              }}
            >
              SELL SWAP.HIVE
            </Button>

            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                if (precio === "") return;
                sell_nft(idNft, precio, "SWAP.HBD");
              }}
            >
              SELL SWAP.HBD
            </Button>

            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                if (precio === "") return;
                sell_nft(idNft, precio, "KOD");
              }}
            >
              SELL KOD
            </Button>

            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                if (precio === "") return;
                sell_nft(idNft, precio, "STARPRO");
              }}
            >
              SELL STARPRO
            </Button>

            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                if (precio === "") return;
                setOpen3(false);
                sell_nft(idNft, precio, "HUESO");
              }}
            >
              SELL HUESO
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </Box>
  );
};